module.exports = __webpack_public_path__ + "static/media/tools-timer.379910c7.svg";